export class Campus {
    id: number;
    name: string;
}

export class Homeroom {
    id: number;
    name: string;
    campusId: number;
    yearLevelId: number;
}
export class Classes {
    id: number;
    name: string;
}
export class Schoolyear {
    id: number;
    name: string;
}

export class YearLevel {
    id: number;
    name: string;
}

export class CampusFullItem {
    id: number;
    name: string;
    yearLevels: YearLevelWithHomerooms[];
}

export class YearLevelWithHomerooms {
    id: number;
    name: string;
    homerooms: Homeroom[];
}

export class Semester {
    id: number;
    name: string;
    schoolYearId: number;
    is_current: boolean;
    start_at: string;
    end_at: string;
}

export class Term {
    id: number;
    name: string;
    start_at: string;
    end_at: string;
    semester_id: number;
}

export class Season {
    id: number;
    name: string;
    schoolYearId: number;
    endDate: string;
    startDate: string;
    schoolYear: {
        id: number;
        name: string;
    };
    isParentBooking: boolean;
    seasonId: number;
    isCurrent: boolean;
    type: string;
    displayName?: string;
}


// WEBPACK FOOTER //
// ./src/common/modules/core/models/Catalog.ts